import { useState, useEffect } from 'react';
import visa from '../../images/icons/cardtypes/visa.svg';
import mastercard from '../../images/icons/cardtypes/mastercard.svg';
import maestro from '../../images/icons/cardtypes/maestro.svg';
import diners from '../../images/icons/cardtypes/diners.svg';
import unknown from '../../images/icons/cardtypes/unknown.svg';

const iconMap = {
    VISA: visa,
    MASTERCARD: mastercard,
    MAESTRO: maestro,
    MAESTROUK: maestro,
    DINERS: diners,
    Unknown: unknown
};

export default function CardTypeIndicator({ supportedCards, cardType }) {
    const [current, setCurrent] = useState('Unknown');
    const [opacity, setOpacity] = useState(1);

    const getIcon = (type) => {
        if (supportedCards?.includes(type) && iconMap[type]) {
            return iconMap[type];
        }
        return iconMap.Unknown;
    };

    useEffect(() => {
        if (cardType && cardType !== current) {
            // fade out
            setOpacity(0);
            const timer = setTimeout(() => {
                setCurrent(cardType);  // change icon
                setOpacity(1);         // fade in
            }, 150);
            return () => clearTimeout(timer);
        }
    }, [cardType, current]);

    return (
        <div className="card-type-indicator-wrapper">
            <img
                src={getIcon(current)}
                alt={current}
                style={{ opacity }}
            />
        </div>
    );
}
